import React from "react";
import { Col, Form, Input, Modal, Row, Select, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL, URL_SETTING } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import { useParams } from "react-router-dom";
import _ from "lodash";

export default function AddPrecursorModal(props) {
  const params = useParams();
  const { open, onClose, target, onUpdate} = props;
  const [selectChemical, setSelectChemical] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'
  const [debouncedLot, setDebouncedLot] = React.useState('');
  const debounceLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedLot(_searchVal) }, 800), []);

  const [debouncedChemical, setDebouncedChemical] = React.useState('');
  const debounceChemical = React.useCallback(_.debounce((_searchVal) => { setDebouncedChemical(_searchVal) }, 800), []);

  const pureChemicalDropdown = useDropdownItem({ manual : true, url: URL_CHEMICAL.PURE_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name : debouncedChemical } })
  const lotPureChemicalDropdown = useDropdownItem({ manual : true, url: URL_CHEMICAL.PURE_CHEMICAL_TRANSACTION, label: 'lot_no', value: 'id', pagination: true, params: { page_size: 999 , lot_no : debouncedLot, is_closed : false}})
  const SupplierChemicalDropDown = useDropdownItem({ manual : true, url: URL_SETTING.SELLER_CHEMICAL, label: 'name', value: 'id', pagination: true, params: { page_size: 999 } })

  const {
    token: { colorWarning },
  } = theme.useToken();

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      data['quality_transaction'] = params.id
      data['amount'] = data['use_amount']
      if(isCreate){
        await POST(URL_CHEMICAL.CHEMICAL_MIX_TRANSACTION, data)
      } else {
        await PATCH(`${URL_CHEMICAL.CHEMICAL_MIX_TRANSACTION}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      pureChemicalDropdown.fetchOptions();
      lotPureChemicalDropdown.fetchOptions();
      SupplierChemicalDropDown.fetchOptions();
      setErrorMessages(null)
      if(isCreate){
        form.resetFields();
      } else {
        form.setFieldsValue(target)
      }
    }
  },[open])

  React.useEffect(() => {
    form.setFieldValue('pure_transaction')
    form.setFieldValue('supplier')
    form.setFieldValue('remain_amount')
    if(selectChemical){
      lotPureChemicalDropdown.fetchOptions({chemical : selectChemical});
    } else {
      lotPureChemicalDropdown.fetchOptions();
    }
  },[selectChemical])

  React.useEffect(() => {
      lotPureChemicalDropdown.fetchOptions();
  },[debouncedLot])

  React.useEffect(() => {
      pureChemicalDropdown.fetchOptions();
  },[debouncedChemical])

	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "ตกลง" : "แก้ไข"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}, loading: loading }}
      cancelText={"ไม่"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มสารตั้งต้น" : "แก้ไขสารตั้งต้น"}
      width={650}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={12}>
            <Form.Item 
              label={'ชื่อสารเคมี'} 
              style={{marginRight : 10}}
              name={"chemical"}
              rules={[{ required : true, message: "กรุณาใส่ชื่อสารเคมี!"  }]}
            >
              <Select
                showSearch
                style={{ width : '100%' }} 
                placeholder={'ชื่อสารเคมี'} 
                options={pureChemicalDropdown.options} 
                filterOption={false}
                allowClear 
                onSelect={setSelectChemical}
                onClear={() => {
                  setSelectChemical(null)
                  form.resetFields();
                }}
                onSearch={debounceChemical}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              label={'Lot No'} 
              style={{marginRight : 10}}
              name={"pure_transaction"}
              rules={[{ required : true, message: "กรุณาใส่เลขที่ล็อต!"  }]}
            >
              <Select
                showSearch
                style={{ width : '100%' }} 
                placeholder={'Lot No.'} 
                options={lotPureChemicalDropdown.options} 
                filterOption={false}
                allowClear 
                onSelect={(value, option) => form.setFieldsValue(option)}
                onClear={() => {
                  lotPureChemicalDropdown.fetchOptions();
                  form.resetFields();
                }}
                onSearch={debounceLot}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item 
              label={'บริษัทผู้จำหน่าย'} 
              style={{marginRight : 10}}
              name={"supplier"}
            >
              <Select style={{ width : '100%' }} placeholder={'บริษัทผู้จำหน่าย'} disabled={true} options={SupplierChemicalDropDown.options} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              label={'ปริมาณคงเหลือ (Kg)'} 
              style={{marginRight : 10}}
              name={"remain_amount"}
            >
              <Input style={{ width : '100%' }} placeholder={'ปริมาณคงเหลือ'} disabled={true} autoComplete="off"/>
            </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
            label="ปริมาณที่ใช้ (Kg)"
            style={{ marginRight: 10 }}
            name="use_amount"
            rules={[
              { required: true, message: 'กรุณาใส่ปริมาณ!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const remainAmount = getFieldValue('remain_amount');

                  if (value == null || remainAmount == null) {
                    return Promise.resolve();
                  }

                  if (Number(value) > Number(remainAmount)) {
                    return Promise.reject(
                      new Error('ปริมาณคงเหลือไม่เพียงพอ')
                    );
                  }

                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input
              style={{ width: '100%' }}
              placeholder="ปริมาณที่ใช้"
              autoComplete="off"
            />
          </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
)
}